'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HASH_ROUTING_UPDATE_ACCESS_TO_ROUTE = exports.HASH_ROUTING_SWITCH_ROUTE = exports.HASH_ROUTING_SET_NEXT_ROUTE = exports.HASH_ROUTING_INIT_ROUTING = exports.Route = undefined;

var _hashRouter = require('./hash-router');

var _hashRouter2 = _interopRequireDefault(_hashRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _hashRouter2.default;
exports.Route = _hashRouter.Route;
exports.HASH_ROUTING_INIT_ROUTING = _hashRouter.HASH_ROUTING_INIT_ROUTING;
exports.HASH_ROUTING_SET_NEXT_ROUTE = _hashRouter.HASH_ROUTING_SET_NEXT_ROUTE;
exports.HASH_ROUTING_SWITCH_ROUTE = _hashRouter.HASH_ROUTING_SWITCH_ROUTE;
exports.HASH_ROUTING_UPDATE_ACCESS_TO_ROUTE = _hashRouter.HASH_ROUTING_UPDATE_ACCESS_TO_ROUTE;